import { render, staticRenderFns } from "./EditWorkInfoBorrower.vue?vue&type=template&id=1633dec5&scoped=true"
import script from "./EditWorkInfoBorrower.vue?vue&type=script&lang=js"
export * from "./EditWorkInfoBorrower.vue?vue&type=script&lang=js"
import style0 from "./EditWorkInfoBorrower.vue?vue&type=style&index=0&id=1633dec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633dec5",
  null
  
)

export default component.exports